module.exports = __webpack_public_path__ + "static/media/close.3ab03298.svg";